// Port of api/fuel/app/classes/filter/search/games/filters/query/other/categories.php
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	name: 'other.categories',
	priority: 73,
	require: function(config, filter) {
		return filter.categories && filter.categories.length > 0
	},
	run: function(config, filter, data, query) {
		var require = [], include = [], exclude = []
		for (var i = 0; i < filter.categories.length; i++) {
			var d = filter.categories[i]
			var s = String(d)
			if (s.charAt(0) === '+' || s.charAt(0) === ' ') require.push(Math.abs(d))
			else if (d < 0) exclude.push(-d)
			else include.push(d)
		}
		if (require.length) {
			var games = DB.query('SELECT game_id AS g FROM game_category WHERE category_id IN(' + Util.in(require) + ') GROUP BY game_id HAVING COUNT(DISTINCT(category_id)) = ' + require.length)
			var ids = Util.pluck(games, 'g')
			if (ids.length) query.where('g.game_id', 'in', ids)
			else query.where('g.game_id', '=', 0)
		}
		if (include.length) {
			var games = DB.query('SELECT DISTINCT game_id AS g FROM game_category WHERE category_id IN(' + Util.in(include) + ')')
			var ids = Util.pluck(games, 'g')
			if (ids.length) query.where('g.game_id', 'in', ids)
		}
		if (exclude.length) {
			var exGames = DB.query('SELECT DISTINCT game_id AS g FROM game_category WHERE category_id IN(' + Util.in(exclude) + ')')
			var exIds = Util.pluck(exGames, 'g')
			if (exIds.length) query.where('g.game_id', 'not in', exIds)
		}
	}
}
